import React from 'react';
import PropTypes from 'prop-types';

import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';
import classNames from 'classnames';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { CdnImageUtils } from 'javascripts/shared/utils/cdn_image_utils';

import styles from 'stylesheets/components/collection_card.module';

export function CollectionCard(props) {
  function trackPostClick() {
    bubEvents.track(`Collection Card - ${props.trackingCategory}`, 'Clicked link', {
      label: 'Collection id',
      value: props.collection.id,
      ...props.trackingProperties,
    });
  }

  const isExpanded = props.size === 'expanded';

  function thumbnailImage() {
    const slug = CdnImageUtils.getCloudinarySlug(props.collection.thumbnailImage);

    if (!slug) {
      return props.collection.thumbnailImage;
    }

    if (!_.isEmpty(props.imageTransformations)) {
      return CdnImageUtils.getOptimizedImage(slug, props.imageTransformations);
    }

    const transforms = [`w_${320 * 2}`, `h_${180 * 2}`, 'c_fill', 'g_auto'];
    return CdnImageUtils.getOptimizedImage(slug, transforms);
  }

  const lazyAttr = props.lazy ? { loading: 'lazy' } : {};

  return (
    <div className={classNames(styles.collectionCard)} data-testid='collection-card'>
      <a
        href={props.collection.url}
        className={classNames([styles.collectionLink, { [styles.expanded]: isExpanded }])}
        onClick={trackPostClick}
      >
        <img src={thumbnailImage()} className={styles.collectionThumbnail} alt='' {...lazyAttr} />
        <div className={styles.content}>
          <p className={styles.title}>{props.collection.title}</p>
          <p className={styles.description} dangerouslySetInnerHTML={{ __html: props.collection.description }}></p>
        </div>
      </a>
    </div>
  );
}

CollectionCard.propTypes = {
  collection: ChirpPropShapes.collection.isRequired,
  lazy: PropTypes.bool,
  size: PropTypes.oneOf(['compact', 'expanded']).isRequired,
  trackingCategory: PropTypes.string.isRequired,
  trackingProperties: PropTypes.object,
  imageTransformations: PropTypes.arrayOf(PropTypes.string),
};

CollectionCard.defaultProps = {
  lazy: false,
  imageTransformations: [],
  trackingProperties: {},
};
